import { render } from "./WorkspaceRow.vue?vue&type=template&id=25a341fa&scoped=true&ts=true"
import script from "./WorkspaceRow.vue?vue&type=script&lang=ts"
export * from "./WorkspaceRow.vue?vue&type=script&lang=ts"

import "./WorkspaceRow.vue?vue&type=style&index=0&id=25a341fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a341fa"]])

export default __exports__